(function () {
  var PRICE_SELECTOR = '[data-shinzo-atc-price], [data-shinzo-sticky-atc-price]';
  var RECHARGE_HOSTS =
    'recharge-subscription-widget, .recharge-subscription-widget, .rc-container, .rc-widget, .rc_container_wrapper';
  var syncTimer = null;
  var intendedPack = null;
  var enforcingPack = false;

  function readConfig() {
    var el = document.getElementById('shinzo-horizon-pdp-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents, moneyFormat) {
    cents = Number(cents) || 0;
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getProductForm() {
    var section = document.querySelector('.product-information');
    if (!section) return null;
    var shopifySection = section.closest('.shopify-section');
    if (!shopifySection) return null;
    var sectionId = shopifySection.id.replace('shopify-section-', '');
    var productId = section.querySelector('sticky-add-to-cart')?.dataset.productId;
    if (!productId) {
      return (
        section.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]')
      );
    }
    return (
      document.querySelector(
        '#shopify-section-' +
          sectionId +
          ' product-form-component[data-product-id="' +
          productId +
          '"] form'
      ) || section.querySelector('form[action*="/cart/add"]')
    );
  }

  function getCurrentVariantId(form) {
    if (!form) return null;
    var checked = form.querySelector('input[name="id"]:checked');
    if (checked && checked.value) return String(checked.value);
    var sel = form.querySelector('select[name="id"]');
    if (sel && sel.value) return String(sel.value);
    var hid = form.querySelector('input[name="id"]');
    if (hid && hid.value) return String(hid.value);
    var sticky = document.querySelector('sticky-add-to-cart');
    if (sticky && sticky.dataset.currentVariantId) return String(sticky.dataset.currentVariantId);
    return null;
  }

  function getActiveSellingPlanId(form) {
    if (!form) return null;
    var selectors = [
      'input[name="selling_plan"]:checked',
      'input[name="selling_plan_id"]:checked',
      'select[name="selling_plan"]',
      'input[name="selling_plan"]',
      'input[name="selling_plan_id"]',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = form.querySelector(selectors[i]);
      if (!el) continue;
      if (el.tagName === 'SELECT') {
        if (el.value) return String(el.value);
        continue;
      }
      if (el.type === 'radio' && !el.checked) continue;
      if (el.value) return String(el.value);
    }
    return getWidgetSellingPlanId();
  }

  function forEachRechargeRoot(callback) {
    document.querySelectorAll(RECHARGE_HOSTS).forEach(function (host) {
      var roots = [host];
      if (host.shadowRoot) roots.push(host.shadowRoot);
      roots.forEach(function (root) {
        if (root) callback(root, host);
      });
    });
  }

  function getWidgetSellingPlanId() {
    var planId = null;
    forEachRechargeRoot(function (root) {
      if (planId) return;
      var selectedBtn =
        root.querySelector('[class*="plans-button__selected"]') ||
        root.querySelector('[class*="rc-plans-button__selected"]');
      if (selectedBtn) {
        var attr =
          selectedBtn.getAttribute('data-selling-plan-id') ||
          selectedBtn.getAttribute('data-selling_plan') ||
          selectedBtn.dataset.sellingPlanId;
        if (attr) planId = String(attr);
      }
      var checkedPlan = root.querySelector(
        'input[type="radio"][name*="selling"]:checked, input[type="radio"][class*="plan"]:checked'
      );
      if (checkedPlan && checkedPlan.value) planId = String(checkedPlan.value);
    });
    return planId;
  }

  function parsePriceText(text) {
    if (!text) return null;
    var cleaned = String(text).replace(/[^\d.,]/g, '').trim();
    if (!cleaned) return null;
    var normalized =
      cleaned.indexOf(',') > -1 && cleaned.indexOf('.') === -1
        ? cleaned.replace(',', '.')
        : cleaned.replace(/,/g, '');
    var amount = parseFloat(normalized);
    if (isNaN(amount)) return null;
    return Math.round(amount * 100);
  }

  function isStrikethroughElement(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;
    if (tag === 'S' || tag === 'DEL' || tag === 'STRIKE') return true;
    var cls = el.className ? String(el.className) : '';
    var part = el.getAttribute ? el.getAttribute('part') || '' : '';
    if (/compare|strike|original-price|full-price|was-price|compare-at/i.test(cls + ' ' + part)) {
      return true;
    }
    try {
      var deco = window.getComputedStyle(el).textDecorationLine || window.getComputedStyle(el).textDecoration;
      return /line-through/i.test(deco || '');
    } catch (e) {
      return false;
    }
  }

  function isStrikethroughContext(el) {
    var node = el;
    var depth = 0;
    while (node && node.nodeType === 1 && depth < 8) {
      if (isStrikethroughElement(node)) return true;
      node = node.parentElement;
      depth += 1;
    }
    return false;
  }

  function visiblePriceText(el) {
    if (!el) return '';
    if (isStrikethroughContext(el) && !el.querySelector('[class*="price"], [class*="amount"]')) {
      return '';
    }
    var clone = el.cloneNode(true);
    var struck = clone.querySelectorAll(
      's, del, strike, [class*="compare"], [class*="strike"], [class*="original-price"], [class*="full-price"], [class*="was-price"]'
    );
    for (var i = 0; i < struck.length; i++) {
      struck[i].remove();
    }
    return clone.textContent;
  }

  function getPriceFromNode(root) {
    if (!root) return null;
    var selectors = [
      '[class*="discounted-price"]',
      '[class*="unit-price"]',
      '[class*="purchase-option__price"]',
      '[class*="option__price"]',
      '[class*="price"]',
    ];
    for (var s = 0; s < selectors.length; s++) {
      var nodes = root.querySelectorAll(selectors[s]);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (isStrikethroughContext(el) && !el.querySelector('[class*="price"], [class*="amount"]')) {
          continue;
        }
        var cents = parsePriceText(visiblePriceText(el));
        if (cents != null) return cents;
      }
    }
    return null;
  }

  function visitRootAndShadows(root, callback) {
    if (!root) return;
    callback(root);
    if (!root.querySelectorAll) return;
    var hosts = root.querySelectorAll('*');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) visitRootAndShadows(hosts[i].shadowRoot, callback);
    }
  }

  function ancestorAttr(el, attr) {
    var node = el;
    var depth = 0;
    var value = '';
    while (node && node.nodeType === 1 && depth < 8) {
      if (attr === 'class') {
        value += ' ' + (node.className ? String(node.className) : '');
      } else if (node.getAttribute) {
        value += ' ' + (node.getAttribute(attr) || '');
      }
      node = node.parentElement;
      depth += 1;
    }
    return value;
  }

  function isBadgeContext(el) {
    return /badge/i.test(ancestorAttr(el, 'class') + ancestorAttr(el, 'part'));
  }

  function isBenefitContext(el) {
    var node = el;
    var depth = 0;
    while (node && node.nodeType === 1 && depth < 8) {
      if (node.tagName === 'LI') return true;
      var cls = node.className ? String(node.className) : '';
      var part = node.getAttribute ? node.getAttribute('part') || '' : '';
      if (/benefit|bullet|perk|check-item|feature-item/i.test(cls + ' ' + part)) return true;
      node = node.parentElement;
      depth += 1;
    }
    return false;
  }

  function decodeHtmlText(value) {
    return String(value || '')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&#0*39;/g, "'")
      .replace(/&quot;/g, '"');
  }

  function escapeHtmlText(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function formatDiscoveryBulletHtml(saveBullet) {
    return escapeHtmlText(saveBullet)
      .replace(/Save\s*\d+(?:\.\d+)?\s*%/i, function (match) {
        return '<strong style="font-weight:700">' + match + '</strong>';
      })
      .replace(/\bfree\b/i, '<strong style="font-weight:700">free</strong>');
  }

  function isInsideDiscoveryCopy(node) {
    var el = node && node.parentElement;
    while (el) {
      if (el.hasAttribute && el.hasAttribute('data-shinzo-discovery-copy')) return true;
      el = el.parentElement;
    }
    return false;
  }

  function replaceSavePercentInText(text, override, parent) {
    if (!text || !override || !override.saveLabel) return null;
    var saveLabel = decodeHtmlText(override.saveLabel);
    var saveBullet = decodeHtmlText(override.saveBullet || saveLabel);
    var inBadge = isBadgeContext(parent);
    var inBenefit =
      isBenefitContext(parent) || /on every order/i.test(text) || /\/cup/i.test(text);

    if (text.indexOf(saveBullet) !== -1) {
      if (inBenefit && !inBadge && text.trim() === saveBullet) {
        return { value: formatDiscoveryBulletHtml(saveBullet), html: true };
      }
      return null;
    }

    if (inBenefit && !inBadge) {
      if (/Save\s*\d/i.test(text) || /on every order/i.test(text) || /\/cup/i.test(text) || /\d+(?:\.\d+)?\s*%/.test(text)) {
        return { value: formatDiscoveryBulletHtml(saveBullet), html: true };
      }
      return null;
    }

    if (text.indexOf(saveLabel) !== -1) return null;

    var next = text.replace(/Save\s*\d+(?:\.\d+)?\s*%/gi, saveLabel);
    if (next !== text) return { value: next, html: false };
    if (/^\s*\d+(?:\.\d+)?\s*%\s*$/.test(text) && inBadge) return { value: saveLabel, html: false };
    return null;
  }

  function applyDiscoverySubscribeOverrideInRoot(root, override) {
    if (!root || !root.querySelectorAll || !document.createTreeWalker) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var pending = [];
    var node;

    while ((node = walker.nextNode())) {
      if (isInsideDiscoveryCopy(node)) continue;
      var text = node.textContent;
      if (!text) continue;

      var next = replaceSavePercentInText(text, override, node.parentElement);
      if (next) pending.push({ node: node, value: next.value, html: next.html });
    }

    for (var i = 0; i < pending.length; i++) {
      var item = pending[i];
      if (!item.node.parentNode) continue;
      if (item.html) {
        var span = item.node.ownerDocument.createElement('span');
        span.setAttribute('data-shinzo-discovery-copy', '');
        span.innerHTML = item.value;
        item.node.parentNode.replaceChild(span, item.node);
      } else {
        item.node.textContent = item.value;
      }
    }
  }

  var applyingDiscoveryOverride = false;

  function applyDiscoverySubscribeOverride(config) {
    var override = config && config.discoverySubscribeOverride;
    if (!config || !config.isDiscovery || !override || !override.enabled) return;
    if (applyingDiscoveryOverride) return;

    applyingDiscoveryOverride = true;
    try {
      forEachRechargeRoot(function (root) {
        visitRootAndShadows(root, function (scope) {
          applyDiscoverySubscribeOverrideInRoot(scope, override);
        });
      });
    } finally {
      applyingDiscoveryOverride = false;
    }
  }

  function getSelectedPurchaseOptionRoot() {
    var selectedOption = null;
    forEachRechargeRoot(function (root) {
      if (selectedOption) return;
      selectedOption =
        root.querySelector('[class*="purchase-option__selected"]') ||
        root.querySelector('[class*="rc-purchase-option__selected"]');
      if (selectedOption) return;
      var checked = root.querySelector(
        'input[type="radio"]:checked, input[type="checkbox"]:checked'
      );
      if (!checked) return;
      var option = checked.closest('[class*="purchase-option"]');
      if (option) selectedOption = option;
    });
    return selectedOption;
  }

  function isSubscriptionPurchaseSelected() {
    if (getActiveSellingPlanId(getProductForm())) return true;
    var option = getSelectedPurchaseOptionRoot();
    if (!option) return false;
    var cls = (option.className || '') + ' ' + (option.getAttribute('class') || '');
    if (/subscription|subsave|subscribe/i.test(cls)) return true;
    if (option.querySelector('[class*="subscription"], [class*="subsave"]')) return true;
    return false;
  }

  function forEachWidgetScope(callback) {
    document.querySelectorAll(RECHARGE_HOSTS).forEach(function (host) {
      callback(host);
      if (host.shadowRoot) visitRootAndShadows(host.shadowRoot, callback);
    });
  }

  function controlLabelText(el) {
    if (!el || el.nodeType !== 1) return '';
    var label = typeof el.closest === 'function' ? el.closest('label') : null;
    var root = typeof el.getRootNode === 'function' ? el.getRootNode() : null;
    if (!label && el.id && root && root.querySelector) {
      label = root.querySelector('label[for="' + el.id.replace(/"/g, '\\"') + '"]');
    }
    var source = label || el;
    return String(source.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isOneTimeControl(el) {
    var text = controlLabelText(el).toLowerCase();
    if (!text || text.length > 160) return false;
    var hasOneTime = /one[-_\s]?time|onetime|one_time/.test(text);
    var hasSubscribe = /subscri/.test(text);
    if (hasOneTime && !hasSubscribe) return true;
    var extra = (
      String(el.value || '') +
      ' ' +
      String(el.getAttribute('data-radio-type') || '') +
      ' ' +
      String(el.getAttribute('data-option') || '') +
      ' ' +
      String(el.className || '')
    ).toLowerCase();
    return /one[-_\s]?time|onetime|one_time/.test(extra) && !/subscri/.test(extra);
  }

  function isOneTimePurchaseSelectedNow() {
    var found = false;
    forEachWidgetScope(function (root) {
      if (found || !root.querySelectorAll) return;
      var controls = root.querySelectorAll(
        'input[type="radio"]:checked, [role="radio"][aria-checked="true"], [aria-pressed="true"]'
      );
      for (var i = 0; i < controls.length; i++) {
        if (!isOneTimeControl(controls[i])) continue;
        found = true;
        return;
      }
    });
    return found;
  }

  function syncDiscoveryGiftPromo() {
    var box = document.querySelector('.shinzo-discovery-whisk');
    if (!box) return;
    var block = box.closest('.shinzo-discovery-whisk-promo-block') || box;
    var hide = isOneTimePurchaseSelectedNow();
    block.hidden = hide;
    box.hidden = hide;
  }

  function getRechargeDisplayedPriceCents() {
    var option = getSelectedPurchaseOptionRoot();
    if (option) {
      var fromOption = getPriceFromNode(option);
      if (fromOption != null) return fromOption;
    }
    return null;
  }

  function resolveSellingPlanPrice(plans, sellingPlanId) {
    if (!plans || !plans.length) return null;
    if (sellingPlanId) {
      for (var i = 0; i < plans.length; i++) {
        if (String(plans[i].id) === String(sellingPlanId)) return plans[i].price;
      }
    }
    return plans[0].price;
  }

  function resolveVariantPriceCents(config, variantId, sellingPlanId) {
    if (!config || !variantId) return null;
    var byId = config.variantsById && config.variantsById[variantId];
    if (byId) {
      if (sellingPlanId || isSubscriptionPurchaseSelected()) {
        var subPrice = resolveSellingPlanPrice(byId.sellingPlans, sellingPlanId);
        if (subPrice != null) return subPrice;
      }
      return byId.price;
    }
    return null;
  }

  function getPackFromVariantId(config, variantId) {
    if (!config || !config.variantIds || !variantId) return null;
    var id = String(variantId);
    if (config.variantIds['25'] != null && String(config.variantIds['25']) === id) return '25';
    if (config.variantIds['10'] != null && String(config.variantIds['10']) === id) return '10';
    return null;
  }

  function resolveInitialPack(config) {
    var fromUrl = null;
    try {
      fromUrl = getPackFromVariantId(config, new URLSearchParams(window.location.search).get('variant'));
    } catch (e) {
      fromUrl = null;
    }
    if (fromUrl) return fromUrl;
    if (config.defaultPack === '25' || config.defaultPack === '10') return config.defaultPack;
    return '10';
  }

  function getActivePack(config) {
    var mount = document.getElementById('shinzo-pack-toggle-wrap');
    if (mount && !mount.hidden) {
      var active = mount.querySelector('[data-pack].is-active');
      if (active) return active.dataset.pack === '25' ? '25' : '10';
    }
    return getPackFromVariantId(config, getCurrentVariantId(getProductForm()));
  }

  function resolvePackPriceCents(config, pack, sellingPlanId) {
    if (!config || !config.prices) return null;
    var key = pack === '25' ? '25' : '10';
    var data = config.prices[key];
    if (!data || data.price == null) return null;
    if (sellingPlanId || isSubscriptionPurchaseSelected()) {
      var subPrice = resolveSellingPlanPrice(data.sellingPlans, sellingPlanId);
      if (subPrice != null) return subPrice;
    }
    return data.price;
  }

  function setPriceText(formatted) {
    document.querySelectorAll(PRICE_SELECTOR).forEach(function (el) {
      el.textContent = formatted;
    });
  }

  function resolveStickyVariantLabel(config) {
    if (config && config.isFlavorWithPacks) {
      var pack = getActivePack(config);
      if (pack) {
        var labels = packToggleLabels(config);
        return pack === '25' ? labels.large : labels.small;
      }
    }

    var form = getProductForm();
    if (!form) return null;

    var select = form.querySelector('select[name="id"]');
    if (select && select.selectedOptions && select.selectedOptions[0]) {
      var optionLabel = select.selectedOptions[0].textContent.trim();
      if (optionLabel) return optionLabel;
    }

    var checked = form.querySelector('input[name="id"]:checked');
    if (checked) {
      var optionLabelNode = checked.closest('label');
      if (optionLabelNode) {
        var labelText = optionLabelNode.textContent.trim();
        if (labelText) return labelText;
      }
    }

    return null;
  }

  function syncStickyVariantLabel(config) {
    var variantTitle = document.querySelector('[data-testid="sticky-variant-title"]');
    if (!variantTitle) return;

    var label = resolveStickyVariantLabel(config);
    if (label) {
      variantTitle.textContent = label;
    }

    var sticky = document.querySelector('sticky-add-to-cart');
    var variantId = getCurrentVariantId(getProductForm());
    if (sticky && variantId) {
      sticky.dataset.currentVariantId = variantId;
    }
  }

  function syncDisplayedPrices(config) {
    if (!config) return;
    syncDiscoveryGiftPromo();
    applyDiscoverySubscribeOverride(config);
    var form = getProductForm();
    var variantId = getCurrentVariantId(form);
    var sellingPlanId = getActiveSellingPlanId(form);
    var moneyFormat = config.moneyFormat || '${{amount}}';
    var cents = null;

    if (variantId) {
      cents = resolveVariantPriceCents(config, variantId, sellingPlanId);
    }

    if (cents == null && config.isFlavorWithPacks) {
      var pack = getActivePack(config);
      if (pack) cents = resolvePackPriceCents(config, pack, sellingPlanId);
    }

    var widgetCents = getRechargeDisplayedPriceCents();
    if (widgetCents != null && !rechargeShowsOtherPack(config)) {
      if (cents == null || sellingPlanId || isSubscriptionPurchaseSelected()) {
        cents = widgetCents;
      }
    }

    if (cents != null) {
      setPriceText(formatMoney(cents, moneyFormat));
    }

    syncStickyVariantLabel(config);
  }

  function scheduleSync(config) {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncDisplayedPrices(config);
    }, 50);
  }

  function targetForms(config) {
    var all = document.querySelectorAll('form[action*="/cart/add"], form[action*="/cart/add.js"]');
    if (!config || !config.isFlavorWithPacks) return Array.from(all);

    var v10 = config.variantIds['10'];
    var v25 = config.variantIds['25'];
    if (v10 == null || v25 == null) return Array.from(all);

    v10 = String(v10);
    v25 = String(v25);
    return Array.from(all).filter(function (form) {
      var sel = form.querySelector('select[name="id"]');
      if (sel && sel.options.length) {
        var vals = Array.from(sel.options).map(function (o) {
          return String(o.value);
        });
        return vals.includes(v10) && vals.includes(v25);
      }
      var hid = form.querySelector('input[name="id"]');
      if (hid) {
        var v = String(hid.value);
        return v === v10 || v === v25;
      }
      return true;
    });
  }

  function dispatch(el) {
    if (!el) return;
    el.dispatchEvent(new Event('change', { bubbles: true }));
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function writeVariantControl(el, idStr) {
    if (!el) return;
    var changed = String(el.value) !== idStr || el.getAttribute('value') !== idStr;
    el.value = idStr;
    el.setAttribute('value', idStr);
    if (changed) dispatch(el);
  }

  function setVariantOnForms(config, variantId) {
    var idStr = String(variantId);
    targetForms(config).forEach(function (form) {
      var sel = form.querySelector('select[name="id"]');
      if (sel) writeVariantControl(sel, idStr);
      var hid = form.querySelector('input[name="id"]');
      if (hid && hid.type !== 'radio') writeVariantControl(hid, idStr);
      form.querySelectorAll('input[name="id"][type="radio"]').forEach(function (radio) {
        var shouldCheck = String(radio.value) === idStr;
        var changed = radio.checked !== shouldCheck;
        radio.checked = shouldCheck;
        if (shouldCheck && changed) dispatch(radio);
      });
    });
  }

  function selectVariantPicker(variantId) {
    var picker = document.querySelector('variant-picker');
    if (!picker || variantId == null) return false;
    var idStr = String(variantId);
    var inputs = picker.querySelectorAll('input[data-variant-id]');
    var target = null;
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var match = String(input.getAttribute('data-variant-id')) === idStr;
      input.dataset.currentChecked = match ? 'true' : 'false';
      if (match) {
        target = input;
      } else {
        input.checked = false;
      }
    }
    if (!target) return false;
    var alreadyChecked = target.checked;
    target.checked = true;
    if (!alreadyChecked) dispatch(target);
    return true;
  }

  function packVariantId(config, pack) {
    if (!config || !config.variantIds) return null;
    return pack === '25' ? config.variantIds['25'] : config.variantIds['10'];
  }

  function syncPackToggleButtons(pack) {
    var mount = document.getElementById('shinzo-pack-toggle-wrap');
    if (!mount) return;
    mount.querySelectorAll('[data-pack]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.pack === pack);
    });
  }

  function enforceIntendedPack(config) {
    if (enforcingPack || !config || !config.isFlavorWithPacks || !intendedPack) return;
    var wanted = packVariantId(config, intendedPack);
    if (wanted == null) return;
    enforcingPack = true;
    var wantedStr = String(wanted);
    var current = getCurrentVariantId(getProductForm());
    if (current !== wantedStr) setVariantOnForms(config, wanted);
    selectVariantPicker(wanted);
    syncPackToggleButtons(intendedPack);
    updatePackSubtitle(config, intendedPack);
    enforcingPack = false;
  }

  function hideVariantPicker() {
    document.querySelectorAll('variant-picker, [data-block-type="variant-picker"]').forEach(function (el) {
      el.setAttribute('data-shinzo-pack-hidden', '');
      el.style.display = 'none';
    });
  }

  function packToggleLabels(config) {
    if (config.isSoda) {
      return { small: '12 cans', large: '24 cans' };
    }
    return { small: '10 pouches', large: '25 pouches' };
  }

  function getPackSubtitleEl() {
    return document.querySelector('[data-shinzo-pack-subtitle]');
  }

  function packSubtitleText(config, pack, el) {
    if (!el) return null;
    if (config.isDiscovery || el.closest('[data-pack-subtitle-static="discovery"]')) {
      return el.dataset.labelDiscovery || '30 pouches · 3 flavors';
    }
    if (config.isSoda) {
      return pack === '25' ? el.dataset.labelSodaLarge : el.dataset.labelSodaSmall;
    }
    if (config.isFlavorWithPacks) {
      return pack === '25' ? el.dataset.labelPouchesLarge : el.dataset.labelPouchesSmall;
    }
    return null;
  }

  function updatePackSubtitle(config, pack) {
    var el = getPackSubtitleEl();
    if (!el || !config) return;
    var text = packSubtitleText(config, pack, el);
    if (text) el.textContent = text;
  }

  function getActivePackFromForm(config) {
    if (!config || !config.variantIds) return '10';
    var form = getProductForm();
    var id = getCurrentVariantId(form);
    if (id != null && String(id) === String(config.variantIds['25'])) return '25';
    return '10';
  }

  function syncPackSaveBadgeStyleFromRecharge() {
    var mount = document.getElementById('shinzo-pack-toggle-wrap');
    if (!mount || mount.dataset.shinzoPackBadgeStyled === 'true') return;

    var rechargeBadge = null;
    forEachRechargeRoot(function (root) {
      if (rechargeBadge) return;
      var candidates = root.querySelectorAll(
        '[class*="badge"], [class*="discount"], [class*="savings"], [class*="subsave"]'
      );
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (!/save\s+\d+\s*%/i.test(el.textContent || '')) continue;
        rechargeBadge = el;
        break;
      }
    });

    if (!rechargeBadge) return;

    var styles = window.getComputedStyle(rechargeBadge);
    if (styles.backgroundColor && styles.backgroundColor !== 'rgba(0, 0, 0, 0)') {
      mount.style.setProperty('--shinzo-pack-save-badge-bg', styles.backgroundColor);
    }
    if (styles.color) {
      mount.style.setProperty('--shinzo-pack-save-badge-color', styles.color);
    }
    if (styles.fontSize) {
      mount.style.setProperty('--shinzo-pack-save-badge-font-size', styles.fontSize);
    }
    if (styles.fontWeight) {
      mount.style.setProperty('--shinzo-pack-save-badge-font-weight', styles.fontWeight);
    }
    if (styles.padding) {
      mount.style.setProperty('--shinzo-pack-save-badge-padding', styles.padding);
    }
    if (styles.lineHeight) {
      mount.style.setProperty('--shinzo-pack-save-badge-line-height', styles.lineHeight);
    }
    mount.dataset.shinzoPackBadgeStyled = 'true';
  }

  function buildPackToggle(config) {
    var mount = document.getElementById('shinzo-pack-toggle-wrap');
    if (!mount || !config.isFlavorWithPacks) return;

    var labels = packToggleLabels(config);
    var saveBadge25 = config.packSaveBadge25 || null;
    var pack25Inner = saveBadge25
      ? '<span class="tp-pack-btn__label">' +
        labels.large +
        '</span><span class="tp-pack-save-badge">' +
        saveBadge25 +
        '</span>'
      : labels.large;

    var initialPack = resolveInitialPack(config);

    mount.hidden = false;
    mount.innerHTML =
      '<div class="tp-pack-seg">' +
      '<button type="button" class="tp-pack-btn' +
      (initialPack === '10' ? ' is-active' : '') +
      '" data-pack="10">' +
      labels.small +
      '</button>' +
      '<button type="button" class="tp-pack-btn' +
      (initialPack === '25' ? ' is-active' : '') +
      '" data-pack="25">' +
      pack25Inner +
      '</button>' +
      '</div>';

    hideVariantPicker();

    function setActive(pack) {
      intendedPack = pack;
      syncPackToggleButtons(pack);
      var vid = packVariantId(config, pack);
      if (vid != null) {
        setVariantOnForms(config, vid);
        selectVariantPicker(vid);
      }
      updatePackSubtitle(config, pack);
      scheduleSync(config);
      document.dispatchEvent(
        new CustomEvent('shinzo:pack-change', {
          bubbles: true,
          detail: { pack: pack },
        })
      );
    }

    mount.querySelector('[data-pack="10"]').addEventListener('click', function () {
      setActive('10');
    });
    mount.querySelector('[data-pack="25"]').addEventListener('click', function () {
      setActive('25');
    });

    setActive(initialPack);
    syncPackSaveBadgeStyleFromRecharge();
  }

  function initPriceSync(config) {
    if (!config) return;

    var form = getProductForm();
    if (form) {
      form.addEventListener('change', function (event) {
        var target = event.target;
        if (!(target instanceof HTMLElement)) return;
        if (
          target.matches(
            'input[name="id"], select[name="id"], input[name="selling_plan"], input[name="selling_plan_id"], select[name="selling_plan"]'
          )
        ) {
          if (target.matches('input[name="id"], select[name="id"]') && config.isFlavorWithPacks) {
            updatePackSubtitle(config, getActivePackFromForm(config));
          }
          scheduleSync(config);
        }
      });
    }

    var section = document.querySelector('.product-information')?.closest('.shopify-section');
    if (section) {
      section.addEventListener('variant:update', function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (config.isFlavorWithPacks) enforceIntendedPack(config);
            scheduleSync(config);
          });
        });
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        if (!document.querySelector('.shinzo-discovery-whisk')) return;
        var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
        var inWidget = false;
        for (var i = 0; i < path.length; i++) {
          var node = path[i];
          if (!(node instanceof Element) || typeof node.matches !== 'function') continue;
          if (node.matches(RECHARGE_HOSTS)) {
            inWidget = true;
            break;
          }
        }
        if (!inWidget) return;
        syncDiscoveryGiftPromo();
        requestAnimationFrame(syncDiscoveryGiftPromo);
      },
      true
    );
    document.addEventListener(
      'change',
      function (event) {
        if (!document.querySelector('.shinzo-discovery-whisk')) return;
        var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
        for (var i = 0; i < path.length; i++) {
          var node = path[i];
          if (!(node instanceof Element) || typeof node.matches !== 'function') continue;
          if (!node.matches(RECHARGE_HOSTS)) continue;
          syncDiscoveryGiftPromo();
          return;
        }
      },
      true
    );

    var observedRechargeRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
    var observeRecharge = function () {
      forEachWidgetScope(function (root) {
        if (!root || root.nodeType !== 1 && root.nodeType !== 11) return;
        if (observedRechargeRoots) {
          if (observedRechargeRoots.has(root)) return;
          observedRechargeRoots.add(root);
        }
        var mo = new MutationObserver(function () {
          syncPackSaveBadgeStyleFromRecharge();
          nudgeRechargeForm(config);
          scheduleSync(config);
        });
        mo.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true,
        });
      });
    };

    observeRecharge();
    document.addEventListener('shopify:section:load', function () {
      observeRecharge();
      scheduleSync(config);
    });

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('recharge-subscription-widget').then(function () {
        enforceIntendedPack(config);
        observeRecharge();
        scheduleSync(config);
      });
      customElements.whenDefined('variant-picker').then(function () {
        enforceIntendedPack(config);
      });
    }

    if (form) {
      var formObserver = new MutationObserver(function () {
        scheduleSync(config);
      });
      formObserver.observe(form, { childList: true, subtree: true, attributes: true });
    }

    scheduleSync(config);
    setTimeout(function () {
      primeRechargeVariant(config);
      enforceIntendedPack(config);
      nudgeRechargeForm(config);
      observeRecharge();
      syncPackSaveBadgeStyleFromRecharge();
      scheduleSync(config);
    }, 400);
    setTimeout(function () {
      primeRechargeVariant(config);
      enforceIntendedPack(config);
      nudgeRechargeForm(config);
      observeRecharge();
      syncPackSaveBadgeStyleFromRecharge();
      scheduleSync(config);
    }, 1200);
  }

  function initPdpLayout() {
    var flags = document.querySelector('[data-shinzo-pdp-is-frother]');
    var section = document.querySelector('.product-information');
    if (!section) return;

    var shopifySection = section.closest('.shopify-section');
    var isFrother = flags && flags.getAttribute('data-shinzo-pdp-is-frother') === 'true';
    section.classList.add('shinzo-pdp');
    if (shopifySection) {
      shopifySection.classList.add('shinzo-pdp');
    }
    section.classList.toggle('shinzo-pdp--frother', isFrother);
    section.classList.toggle('shinzo-pdp--hide-price', !isFrother);
    if (shopifySection) {
      shopifySection.classList.toggle('shinzo-pdp--frother', isFrother);
      shopifySection.classList.toggle('shinzo-pdp--hide-price', !isFrother);
    }

    if (isFrother) {
      section.querySelectorAll('.shopify-app-block.recharge-subscription-widget').forEach(function (el) {
        el.style.display = 'none';
      });
    }

    tightenDescriptionFlavorGap();
  }

  function tightenDescriptionFlavorGap() {
    var flavor = document.querySelector('.shinzo-pdp-flavor');
    if (!flavor) return;

    var flavorRoot = flavor.closest('.shinzo-pdp-flavor-select-root');
    if (!flavorRoot) return;

    var prev = flavorRoot.previousElementSibling;
    while (prev) {
      if (prev.querySelector('.shinzo-pdp-description')) break;
      var rte = prev.querySelector('rte-formatter.rte, .text-block.rte');
      if (rte && !rte.querySelector('h1')) {
        rte.classList.add('shinzo-pdp-description__content');
        prev.classList.add('shinzo-pdp-description-legacy');
        if (prev.classList.contains('text-block')) {
          prev.classList.add('shinzo-pdp-description-block');
        }
        break;
      }
      if (prev.querySelector('h1')) break;
      prev = prev.previousElementSibling;
    }
  }

  var rechargeNudgeCount = 0;

  function variantPriceList(config, variantId) {
    var data = config && config.variantsById && config.variantsById[String(variantId)];
    if (!data) return [];
    var prices = [];
    if (data.price != null) prices.push(Number(data.price));
    if (data.compare_at != null) prices.push(Number(data.compare_at));
    var plans = data.sellingPlans || [];
    for (var i = 0; i < plans.length; i++) {
      if (plans[i].price != null) prices.push(Number(plans[i].price));
      if (plans[i].compare_at != null) prices.push(Number(plans[i].compare_at));
    }
    return prices;
  }

  function rechargeShowsOtherPack(config) {
    if (!config || !intendedPack) return false;
    var shown = getRechargeDisplayedPriceCents();
    if (shown == null) return false;
    var wantedPrices = variantPriceList(config, packVariantId(config, intendedPack));
    if (wantedPrices.indexOf(shown) !== -1) return false;
    var otherPack = intendedPack === '25' ? '10' : '25';
    return variantPriceList(config, packVariantId(config, otherPack)).indexOf(shown) !== -1;
  }

  function primeRechargeVariant(config) {
    if (!config || !config.isFlavorWithPacks) return;
    var pack = intendedPack || resolveInitialPack(config);
    var vid = packVariantId(config, pack);
    if (vid == null) return;
    var idStr = String(vid);
    document.querySelectorAll('recharge-subscription-widget').forEach(function (widget) {
      if (widget.getAttribute('default-variant-id') !== idStr) {
        widget.setAttribute('default-variant-id', idStr);
      }
    });
  }

  function nudgeRechargeForm(config) {
    if (!config || rechargeNudgeCount > 4 || !rechargeShowsOtherPack(config)) return;
    var wanted = packVariantId(config, intendedPack);
    if (wanted == null) return;
    var form = getProductForm();
    var input = form && form.querySelector('input[name="id"]');
    if (!input) return;
    rechargeNudgeCount += 1;
    var other = packVariantId(config, intendedPack === '25' ? '10' : '25');
    if (other != null) input.setAttribute('value', String(other));
    input.value = String(wanted);
    input.setAttribute('value', String(wanted));
  }

  function boot() {
    if (boot.done) return;
    boot.done = true;

    initPdpLayout();

    var config = readConfig();
    primeRechargeVariant(config);
    initPriceSync(config);

    if (config && config.isFlavorWithPacks) {
      buildPackToggle(config);
    } else if (config) {
      updatePackSubtitle(config, getActivePackFromForm(config));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
